import request from "root/js/request";

export const getAnalyticsProductsGluing = async ({
  imt_id,
  cabinet_id__in,
  subject_id__in,
  brand_id__in,
  period,
  ...rest
}) => {
  const response = await request({
    url: "/analytics/v3/products_gluing/",
    method: "get",
    params: {
      imt_id,
      cabinet_id__in,
      subject_id__in,
      brand_id__in,
      period,
      ...rest,
    },
  });
  return response.data;
};
